module.exports = __webpack_public_path__ + "7a9d36ebfb9434d8202f4f688cc7a855.png";